import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StaffListOuterContainer = styled(Box)(({ theme }) => ({
  maxHeight: '80vh',
  overflowY: 'auto',
  paddingRight: 10,
  [theme.breakpoints.down('md')]: {
    marginBottom: 48,
  },
}));

export const AssignmentPanelTitleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  marginBottom: 16,
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    marginBottom: 10,
    gap: 6,
  },
}));

export const AssignmentPanelTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.4rem',
  color: '#1976d2',
  letterSpacing: 1,
  [theme.breakpoints.down('md')]: {
    fontSize: '1.1rem',
    letterSpacing: 0.5,
  },
}));

export const searchBarBox = {
  margin: '18px 0 12px 0',
  '@media (max-width: 600px)': {
    margin: '8px 0 8px 0'
  }
};

export const noStaffText = {
  textAlign: "center",
  color: "#aaa",
  margin: "30px 0"
};

export const staffPrimaryText = {
  fontSize: '1.3em',
  '@media (max-width: 600px)': {
    fontSize: '1.05em'
  }
};

export const staffEmailText = {
  fontSize: '1em',
  color: '#1e88e5',
  fontWeight: 500,
  '@media (max-width: 600px)': {
    fontSize: '0.92em'
  }
};

export const staffPhoneText = {
  fontSize: '1em',
  color: '#0288d1',
  '@media (max-width: 600px)': {
    fontSize: '0.92em'
  }
};